<template>
<div class='activity_info-overlay'>
  <button
    ref='close-button'
    class='activity_info-overlay_close'
    title='Close'
    @click.prevent='toggleInfoOverlay'
  >
    <CloseIcon />
  </button>

  <div
    v-if='image'
    class='activity_info-overlay_bg'
    :style="{backgroundImage: 'url(' + image + ')'}"
   />

  <!-- CTA -->
  <div
    v-if='overlay'
    class='activity_info-overlay_overlay'
  >
    <h2
      v-if='overlay.headline'
      class='activity_info-overlay_headline h-two-light'
    >
      {{ overlay.headline }}
    </h2>

    <div
      v-if='overlay.subheadline'
      class='activity_info-overlay_description body-one-light'
    >
      {{ overlay.subheadline }}
    </div>

    <div
      v-if='overlay.cta'
      class='activity_info-overlay_cta'
    >
      <a
        class='activity_info-overlay_cta-button button-one-light'
        :href='overlay.cta.href'
        target='_blank'
      >
        {{ overlay.cta.title }}
      </a>
    </div>
  </div>

  <!-- Resources Carousel -->
  <div
    v-if='resources && resources.length'
    class='activity_info-overlay_resources'
  >
    <div class='activity_info-overlay_resources-title'>
      {{ $t('related_resources') }}
    </div>

    <div class='activity_info-overlay_resources-carousel'>
      <CardSlider
        :autoplay='false'
        :cards='resources_as_cards'
        :cardClick='resourceClick'
        :centerIfLessItems='true'
        :infinite='false'
        :miniMode='true'
        :mouseDrag='true'
        :speed='4000'
        :hideType='true'
      />
    </div>
  </div>

  <!-- Powered by -->
  <div
    v-if='tbk_label_visible'
    class='activity_info-overlay_powered-by'
  >
    <img
      class='activity_info-overlay_powered-by-image'
      :src='icons.powered_by_for_activity'
      alt='Powered by TheBigKnow'
    >
  </div>
</div>
</template>

<script>
import CardSlider from 'components/Shared/CardSlider/CardSlider'
import IconMixin from '../icon-mixin'

export default {
  mixins: [IconMixin],

  props: [
    'toggleInfoOverlay',
    'toggleResourceOverlay',
    'overlay',
    'resources',
    'image',
    'tbk_label_visible'
  ],

  components: {
    CardSlider
  },

  data() {
    return {
    }
  },

  computed: {
    resources_as_cards() {
      const cards = this.resources.map((resource) => {
        let image = null
        if (resource.card_image) {
          image = resource.card_image
        } else if (resource.activity && resource.activity.background_image) {
          image = resource.activity.background_image
        }

        return {
          id:           resource.id,
          image,
          type:         this._getResourceType(resource),
          headline:     resource.headline,
          activity:     resource.activity
        }
      })

      return cards
    }
  },

  methods: {
    resourceClick(resource) {
      this.toggleResourceOverlay(resource)
    },

    _getResourceType(resource) {
      const type = resource.activity ? resource.activity.type : resource.type
      const link = resource.activity ? resource.activity.link : resource.link

      switch (type) {
        case 'activity_v1_videos': return 'video'
        case 'activity_v1_audios': return 'audio'
        case 'activity_v1_articles': return 'article'
        case 'activity_v1_resources':
          if (link.href.match(/pdf/) !== null) return 'PDF'
          if (link.href.match(/file/) !== null) return 'download'
          break
        default: return 'link'
      }
    }

  }

}
</script>

<style lang='sass' scoped>
@import './info-overlay'
</style>
